import React, { useState } from "react";
import Header from "../../master/SideBar";
import Nav from "../../master/NavBar";
import Footer from "../footer";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { getstaffwithid } from '../../../api/FacultyService'


const ProfileTab = ({ }) => {
    const { id } = useParams();
    // console.log("Fetched ID from URL:", id);
    const navigate = useNavigate();
    const [Teachers, setTeachers] = React.useState([]);
    const [error, setError] = useState('')


    return (
        <div className="">
            <div className="card mb-6">
                <div className="card-datatable table-responsive mb-n8">
                    <div
                        id="DataTables_Table_0_wrapper"
                        className="dataTables_wrapper dt-bootstrap5 no-footer"
                    >
                        <div className="card-header d-flex flex-wrap row-gap-5">
                            <div className="project-head-label">
                                <h5 className="card-title mb-0">Allocated batches</h5>
                            </div>
                            {/* <div className=" text-end pt-0 my-n5">
                                <div
                                    id="DataTables_Table_0_filter"
                                    className="dataTables_filter"
                                >
                                    <label>
                                        <input
                                            type="search"
                                            className="form-control form-control-sm ms-0"
                                            placeholder="Search Project"
                                            aria-controls="DataTables_Table_0"
                                        />
                                    </label>
                                </div>
                            </div> */}
                        </div>
                        <table
                            className="table datatable-project table-border-bottom-0 dataTable no-footer dtr-column"
                            id="DataTables_Table_0"
                        >
                            <thead>
                                <tr>
                                    <th
                                        className="control sorting_disabled dtr-hidden"
                                        rowSpan={1}
                                        colSpan={1}
                                        style={{ width: "22.9297px", display: "none" }}
                                        aria-label=""
                                    />
                                    <th
                                        className="sorting sorting_desc"
                                        tabIndex={0}
                                        aria-controls="DataTables_Table_0"
                                        rowSpan={1}
                                        colSpan={1}
                                        style={{ width: "123.086px" }}
                                        aria-sort="descending"
                                        aria-label="Project: activate to sort column ascending"
                                    >
                                        Project
                                    </th>
                                    <th
                                        className="text-nowrap sorting"
                                        tabIndex={0}
                                        aria-controls="DataTables_Table_0"
                                        rowSpan={1}
                                        colSpan={1}
                                        style={{ width: "153.664px" }}
                                        aria-label="Total Task: activate to sort column ascending"
                                    >
                                        Total Task
                                    </th>
                                    <th
                                        className="sorting"
                                        tabIndex={0}
                                        aria-controls="DataTables_Table_0"
                                        rowSpan={1}
                                        colSpan={1}
                                        style={{ width: "138.25px" }}
                                        aria-label="Progress: activate to sort column ascending"
                                    >
                                        Progress
                                    </th>
                                    <th
                                        className="sorting_disabled"
                                        rowSpan={1}
                                        colSpan={1}
                                        style={{ width: "94.7344px" }}
                                        aria-label="Hours"
                                    >
                                        Hours
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr className="odd">
                                    <td valign="top" colSpan={4} className="dataTables_empty">
                                        Loading...
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            {/* /Project table */}
            {/* Activity Timeline */}
            <div className="card mb-6">
                <h5 className="card-header">Documents & Joining Details</h5>
                <div className="card-body pt-0">
                    <ul className="timeline mb-0">
                        <li className="timeline-item timeline-item-transparent">
                            <span className="timeline-point timeline-point-primary" />
                            <div className="timeline-event">
                                <div className="timeline-header mb-3">
                                    <h6 className="mb-0">12 Invoices have been paid</h6>
                                    <small className="text-muted">12 min ago</small>
                                </div>
                                <p className="mb-2">Invoices have been paid to the company</p>
                                <div className="d-flex align-items-center mb-1">
                                    <div className="badge bg-lightest">
                                        <img
                                            src="../../assets//img/icons/misc/pdf.png"
                                            alt="img"
                                            width={15}
                                            className="me-2"
                                        />
                                        <span className="h6 mb-0">invoices.pdf</span>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li className="timeline-item timeline-item-transparent">
                            <span className="timeline-point timeline-point-success" />
                            <div className="timeline-event">
                                <div className="timeline-header mb-3">
                                    <h6 className="mb-0">Client Meeting</h6>
                                    <small className="text-muted">45 min ago</small>
                                </div>
                                <p className="mb-2">Project meeting with john @10:15am</p>
                                <div className="d-flex justify-content-between flex-wrap gap-2">
                                    <div className="d-flex flex-wrap align-items-center">
                                        <div className="avatar avatar-sm me-2">
                                            <img
                                                src="../../assets/img/avatars/1.png"
                                                alt="Avatar"
                                                className="rounded-circle"
                                            />
                                        </div>
                                        <div>
                                            <p className="mb-0 small fw-medium">
                                                Lester McCarthy (Client)
                                            </p>
                                            <small>CEO of ThemeSelection</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li className="timeline-item timeline-item-transparent">
                            <span className="timeline-point timeline-point-info" />
                            <div className="timeline-event">
                                <div className="timeline-header mb-3">
                                    <h6 className="mb-0">Create a new project for client</h6>
                                    <small className="text-muted">2 Day Ago</small>
                                </div>
                                <p className="mb-2">6 team members in a project</p>
                                <ul className="list-group list-group-flush">
                                    <li className="list-group-item d-flex justify-content-between align-items-center flex-wrap p-0">
                                        <div className="d-flex flex-wrap align-items-center">
                                            <ul className="list-unstyled users-list d-flex align-items-center avatar-group m-0 me-2">
                                                <li
                                                    data-bs-toggle="tooltip"
                                                    data-popup="tooltip-custom"
                                                    data-bs-placement="top"
                                                    className="avatar pull-up"
                                                    aria-label="Vinnie Mostowy"
                                                    data-bs-original-title="Vinnie Mostowy"
                                                >
                                                    <img
                                                        className="rounded-circle"
                                                        src="../../assets/img/avatars/5.png"
                                                        alt="Avatar"
                                                    />
                                                </li>
                                                <li
                                                    data-bs-toggle="tooltip"
                                                    data-popup="tooltip-custom"
                                                    data-bs-placement="top"
                                                    className="avatar pull-up"
                                                    aria-label="Allen Rieske"
                                                    data-bs-original-title="Allen Rieske"
                                                >
                                                    <img
                                                        className="rounded-circle"
                                                        src="../../assets/img/avatars/12.png"
                                                        alt="Avatar"
                                                    />
                                                </li>
                                                <li
                                                    data-bs-toggle="tooltip"
                                                    data-popup="tooltip-custom"
                                                    data-bs-placement="top"
                                                    className="avatar pull-up"
                                                    aria-label="Julee Rossignol"
                                                    data-bs-original-title="Julee Rossignol"
                                                >
                                                    <img
                                                        className="rounded-circle"
                                                        src="../../assets/img/avatars/6.png"
                                                        alt="Avatar"
                                                    />
                                                </li>
                                                <li className="avatar">
                                                    <span
                                                        className="avatar-initial rounded-circle pull-up text-heading"
                                                        data-bs-toggle="tooltip"
                                                        data-bs-placement="bottom"
                                                        data-bs-original-title="3 more"
                                                    >
                                                        +3
                                                    </span>
                                                </li>
                                            </ul>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            {/* /Activity Timeline */}
        </div>
    );
}

export default ProfileTab;